import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import PublicLayout from "@/components/PublicLayout";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Portfolio from "@/pages/Portfolio";
import Packages from "@/pages/Packages";
import Process from "@/pages/Process";
import ReferEarn from "@/pages/ReferEarn";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import Legal from "@/pages/Legal";

import Login from "@/pages/Login";
import PartnerRegister from "@/pages/PartnerRegister";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import RefRedirect from "@/pages/RefRedirect";

import AdminDashboard from "@/pages/AdminDashboard";
import ClientPortal from "@/pages/ClientPortal";
import PartnerDashboard from "@/pages/PartnerDashboard";

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" theme="dark" richColors />
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/packages" element={<Packages />} />
            <Route path="/process" element={<Process />} />
            <Route path="/refer-earn" element={<ReferEarn />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/legal/:doc" element={<Legal />} />
          </Route>

          <Route path="/refer/:code" element={<RefRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin/login" element={<Login adminMode />} />
          <Route path="/partner/register" element={<PartnerRegister />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
          <Route path="/client" element={<ProtectedRoute role="client"><ClientPortal /></ProtectedRoute>} />
          <Route path="/partner" element={<ProtectedRoute role="partner"><PartnerDashboard /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
